// angularjs-datepicker's date-typer listens for keyup/blur on its input and calls $scope.$apply from
// there. A blur is not always a browser event: angular-auto-validate focuses the first invalid field
// from inside its own ng-submit $apply, and if the date input had focus at the time, its blur runs
// mid-digest and the datepicker's $apply throws $rootScope:inprog. Each datepicker has an isolate
// scope, so its $apply is made safe on that scope alone: inside a digest the work is queued onto the
// running one instead.
app.config([
	"$provide",
	function ($provide) {
		$provide.decorator("datepickerDirective", [
			"$delegate",
			function ($delegate) {
				const directive = $delegate[0];
				const link = directive.link;

				directive.compile = function () {
					return function (scope) {
						const apply = scope.$apply;

						scope.$apply = function (expr) {
							if (scope.$root.$$phase) {
								scope.$evalAsync(expr);
								return;
							}
							return apply.call(scope, expr);
						};

						return link.apply(this, arguments);
					};
				};

				return $delegate;
			},
		]);
	},
]);
